/** @file Save dialog: name + optional team. */
import { h } from "./dom.js";
import { openModal } from "./modal.js";

/** @typedef {import("../types/schemas.js").TeamDoc} TeamDoc */

/**
 * @param {{ initialName?: string, teams?: TeamDoc[], submitLabel?: string }} opts
 * @returns {Promise<{ name: string, teamId: string | null } | null>}
 */
export function openSaveDialog(opts = {}) {
  const { initialName = "", teams = [], submitLabel = "Speichern" } = opts;
  return openModal((close) => {
    const nameInput = /** @type {HTMLInputElement} */ (
      h("input", {
        type: "text",
        required: true,
        maxLength: 80,
        value: initialName,
        class: "hb-auth-input",
        autofocus: true,
      })
    );
    const select = /** @type {HTMLSelectElement} */ (
      h("select", { class: "hb-auth-input" }, [
        h("option", { value: "" }, ["Kein Team"]),
        ...teams.map((t) => h("option", { value: t.id }, [t.name])),
      ])
    );
    const errorEl = h("div", { class: "text-sm text-red-400 min-h-5", role: "alert" });

    const submit = h(
      "button",
      { type: "submit", class: "hb-btn hb-btn--primary min-h-11" },
      [submitLabel],
    );
    const cancel = h("button", { type: "button", class: "hb-btn min-h-11" }, ["Abbrechen"]);
    cancel.addEventListener("click", () => close(null));

    const form = h("form", { class: "flex flex-col gap-3" }, [
      h("h2", { class: "text-xl font-bold" }, ["Spielzug speichern"]),
      h("label", { class: "flex flex-col gap-1 text-sm" }, [
        h("span", null, ["Spielzug-Name"]),
        nameInput,
      ]),
      h("label", { class: "flex flex-col gap-1 text-sm" }, [
        h("span", null, ["Team anwenden und zuweisen (optional)"]),
        select,
      ]),
      errorEl,
      h("div", { class: "flex gap-2 justify-end mt-2" }, [cancel, submit]),
    ]);
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const name = nameInput.value.trim();
      if (!name) {
        errorEl.textContent = "Bitte einen Namen eingeben";
        return;
      }
      const teamId = select.value || null;
      close({ name, teamId });
    });
    setTimeout(() => nameInput.focus(), 0);
    return form;
  });
}
